<template>
  <div class="auth-page">
    <v-card class="auth-card" elevation="4" rounded="lg">
      <v-card-text class="auth-card__body">
        <!-- Brand lockup (docs/BRAND.md) -->
        <div class="auth-card__brand">
          <img src="@/assets/brand/logo.svg" alt="" width="48" height="48" />
          <span class="auth-card__name">Québec <span class="auth-card__accent">Eau Vive</span></span>
        </div>
        <h1 class="auth-card__title">{{ title }}</h1>
        <p v-if="subtitle" class="auth-card__subtitle">{{ subtitle }}</p>
        <!-- Short screens: compact fields, so the main button stays above the partner strip -->
        <v-defaults-provider :defaults="fieldDefaults">
          <slot></slot>
        </v-defaults-provider>
      </v-card-text>
      <div v-if="$slots.footer" class="auth-card__footer">
        <slot name="footer"></slot>
      </div>
    </v-card>
  </div>
</template>

<script>
  // Frame of the sign-in pages (connexion, création de compte, mot de passe oublié): a centred card with the brand
  // lockup on a pale drop-coloured background.
  export default {
    name: "AuthCard",
    props: {
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: "",
      },
    },
    computed: {
      // Same limit as the compact partner strip (PartnersCaroussel.vue) and the max-height styles below
      fieldDefaults() {
        return this.$vuetify.display.height <= 900 ? { VTextField: { density: "compact" } } : {};
      },
    },
  };
</script>

<style scoped>
  .auth-page {
    display: flex;
    justify-content: center;
    padding: 32px 16px 48px;
    min-height: 100%;
    background: linear-gradient(180deg, rgb(var(--v-theme-primary-tint)) 0%, rgb(var(--v-theme-background)) 320px);
  }

  .auth-card {
    width: 100%;
    max-width: 460px;
    align-self: flex-start;
  }

  .auth-card__body {
    padding: 28px 28px 20px;
  }

  .auth-card__brand {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  .auth-card__name {
    font-size: 1.3rem;
    font-weight: 800;
    letter-spacing: -0.3px;
    color: var(--qww-hero-wordmark);
  }

  .auth-card__accent {
    font-weight: 400;
    color: var(--qww-hero-kicker);
  }

  .auth-card__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: rgb(var(--v-theme-on-surface));
    line-height: 1.2;
    margin: 0 0 4px;
  }

  .auth-card__subtitle {
    margin: 0 0 20px;
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  }

  .auth-card__footer {
    padding: 14px 28px 18px;
    border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
    font-size: 0.9rem;
    text-align: center;
  }

  /* Short screens: the main button stays above the partner strip without scrolling. The subtitle goes, the
     notes in the card stay. */
  @media (max-height: 900px) {
    .auth-page {
      padding-top: 16px;
    }

    .auth-card__body {
      padding-top: 20px;
    }

    .auth-card__brand {
      margin-bottom: 12px;
    }

    .auth-card__title {
      margin-bottom: 14px;
    }

    .auth-card__subtitle {
      display: none;
    }
  }

  /* Short phones: the app bar right above already shows the brand */
  @media (max-width: 600px) and (max-height: 900px) {
    .auth-card__brand {
      display: none;
    }
  }

  @media (max-width: 600px) {
    .auth-page {
      padding: 12px 12px 32px;
    }

    .auth-card__body {
      padding: 22px 18px 16px;
    }

    .auth-card__footer {
      padding: 12px 18px 16px;
    }
  }
</style>
